import { BaseState } from '@/store/base-state';
import { Repairs } from '../../../types';

export default class WarrantyState extends BaseState {
  warranty_loading = false;
  warranty_data: Repairs.Warranty[] = [];
  extended_warranties: Repairs.ExtendedWarranty[] = [];
}
